import { useEffect } from "react"
import PageContainer from "../components/PageContainer"
import PageTitle from "../components/PageTitle"
import { useDispatch, useSelector } from "react-redux"
import { getAllCompanies, setIsNeedCompaniesRefresh } from "../redux/adminCompaniesSlice"
import AdminPanel from "../components/AdminPanel"
import { GreenButton } from "../components/buttons"
import AdminCard from "../components/AdminCard"
import Loader from "../components/Loader"
import Error from "../components/Error"
import { setBacklink } from "../redux/backlinkSlice"

const HandleCompanies = () => {
    const { data, isLoading, error, count, isNeedRefresh } = useSelector(state => state.adminCompanies);
    const dispatch = useDispatch();

    // Eseguo la chiamata iniziale ad admin-companies
    useEffect(() => {
        if (!data) {
            dispatch(getAllCompanies())
        }
    }, [data])

    // Imposto il backlink su "/"
    useEffect(() => {
        dispatch(setBacklink("/"))
    }, [])

    useEffect(() => {
        if (isNeedRefresh) {
            dispatch(getAllCompanies());
            dispatch(setIsNeedCompaniesRefresh(false));
        }
    }, [isNeedRefresh])

    return (
        <PageContainer px="4" desktopItems="center">
            <PageTitle title="Gestione aziende" backLink="/" />

            <div className="SPLITPAGE flex flex-col md:flex-row gap-8">

                {/* Right */}
                <AdminPanel />

                {/* Left */}
                <div className="w-full max-w-[1000px] lg:min-w-[1000px]">

                    <div className="w-full flex justify-end mb-8">
                        <GreenButton text="Aggiungi azienda" link="/add-edit-company" isFull />
                    </div>

                    <div className="flex flex-col gap-2 w-full">

                        {/* Cards */}
                        {
                            !isLoading && !error && data && data.length > 0 && data.map((element, index) => {
                                return <AdminCard key={index} elementData={element} type="Company" />
                            })
                        }
                        {isLoading && <Loader isMobileCenter />}
                        {error && <Error message={error.message || 'Errore sconosciuto'} />}

                    </div>
                </div>

            </div>

        </PageContainer>
    )
}

export default HandleCompanies